export const iconFontAwesomeChartsDiagramsCircleHalfStroke = (
	<i className="fa-solid fa-circle-half-stroke"></i>
);
